<script lang="ts">
  /**
   * This component has customizable attributes of SVG icons.
   * We can use SVG icons in a better way inside other Svelte components like so:
   * --------------------------------------------------------------------------
   * import Svg from "../Components/Svg.svelte"
   */

  /** defines the SVG icon */
  export let data: string = ""

  /** It defines the lengths and coordinates of the SVG and how they should be scaled to fit the available space */
  export let viewBox: string | undefined = extractViewBox(data)

  /** Width and height of the svg */
  export let size: string | undefined = undefined

  /** in case height and width are different, overwrite size value */
  export let width: string | undefined = size

  /** in case height and width are different, overwrite size value */
  export let height: string | undefined = size

  /** is an inderect value for currentcolor, stroke and fill */
  export let color: string = "#ffffff"

  /** defines the outline color of the SVG pattern */
  export let stroke: string = color

  /** defines the outline color of the SVG pattern */
  export let strokeWidth: string = "0.1px"

  /** defines the color of the SVG-pattern/shape */
  export let fill: string = color

  /**
   * alt text for image
   *
   * LE: as `alt` is not supported by `<svg>` tag,
   * we use aria-label instead
   *
   * @see https://svgwg.org/svg2-draft/struct.html#implicit-aria-semantics
   */
  export let alt: string | undefined = undefined

  $: elements = data.replace(/<svg ([^>]*)>/, "").replace("</svg>", "")
  $: testId = alt?.replace(/\s+/g, "-")?.toLowerCase()

  function extractViewBox(svg: string) {
    const regex = /viewBox="([\d ]+)"/
    const res = regex.exec(svg)
    if (!res) return "0 0 20 20" // default value
    return res[1]
  }
</script>

<!-- Assign size attribute as a class name for further styling in the CSS -->
<svg
  on:click
  data-testid={`svg-icon-${testId}`}
  xmlns="http://www.w3.org/2000/svg"
  aria-label={alt}
  {width}
  {height}
  {viewBox}
  {stroke}
  stroke-width={strokeWidth}
  {fill}
  {...$$restProps}
>
  {@html elements}
</svg>
